import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation Login($input: UsersPermissionsLoginInput!) {
    login(input: $input) {
      jwt
      user {
        username
        email
        name
      }
    }
  }
`;

export const REGISTER = gql`
  mutation Register($input: UsersPermissionsRegisterInput!) {
    register(input: $input) {
      jwt
      user {
        username
        email
        name
      }
    }
  }
`;

export const DELETE_WORKOUT = gql`
  mutation DeleteWorkout($workoutId: ID!) {
    deleteWorkout(id: $workoutId) {
      data {
        id
      }
    }
  }
`;

export const CREATE_WORKOUT = gql`
  mutation createWorkout($workoutInput: WorkoutInput!) {
    createWorkout(data: $workoutInput) {
      data {
        id
      }
    }
  }
`;

export const UPDATE_WORKOUT = gql`
  mutation updateWorkout($workoutInput: WorkoutInput!, $workoutId: ID!) {
    updateWorkout(data: $workoutInput, id: $workoutId) {
      data {
        id
      }
    }
  }
`;

export const DELETE_DIET_PLAN = gql`
  mutation DeleteDietPlan($dietPlanId: ID!) {
    deleteDietPlan(id: $dietPlanId) {
      data {
        id
      }
    }
  }
`;

export const CREATE_DIET_PLAN = gql`
  mutation CreateDietPlan($dietPlanInput: DietPlanInput!) {
    createDietPlan(data: $dietPlanInput) {
      data {
        id
      }
    }
  }
`;

export const UPDATE_DIET_PLAN = gql`
  mutation UpdateDietPlan($dietPlanInput: DietPlanInput!, $dietPlanId: ID!) {
    updateDietPlan(data: $dietPlanInput, id: $dietPlanId) {
      data {
        id
      }
    }
  }
`;

export const CREATE_WORKOUT_LOG = gql`
  mutation CreateWorkoutLog($workoutLogInput: WorkoutLogInput!) {
    createWorkoutLog(data: $workoutLogInput) {
      data {
        id
      }
    }
  }
`;

export const DELETE_WORKOUT_LOG = gql`
  mutation DeleteWorkoutLog($workoutLogId: ID!) {
    deleteWorkoutLog(id: $workoutLogId) {
      data {
        id
      }
    }
  }
`;

export const CREATE_CALORIE_LOG = gql`
  mutation CreateCalorieLog($data: CalorieLogInput!) {
    createCalorieLog(data: $data) {
      data {
        id
        attributes {
          date
          entries
          totalCalories
        }
      }
    }
  }
`;

export const UPDATE_CALORIE_LOG = gql`
  mutation UpdateCalorieLog($id: ID!, $data: CalorieLogInput!) {
    updateCalorieLog(id: $id, data: $data) {
      data {
        id
        attributes {
          date
          entries
          totalCalories
        }
      }
    }
  }
`;

export const DELETE_CALORIE_LOG = gql`
  mutation DeleteCalorieLog($id: ID!) {
    deleteCalorieLog(id: $id) {
      data {
        id
      }
    }
  }
`;

export const CREATE_GPT = gql`
  mutation CreateGpt($gptInput: GptInput!) {
    createGpt(data: $gptInput) {
      data {
        gptResponse
      }
    }
  }
`;

export const SAVE_ACADEMY_PROGRESS = gql`
  mutation SaveAcademyProgress($youtubeId: String!, $position: Int, $duration: Int, $done: Boolean) {
    saveAcademyProgress(youtubeId: $youtubeId, position: $position, duration: $duration, done: $done)
  }
`;

// "Pontos para a consulta": the plan's numbers (computed on the site, no photo) worded into points by the AI. Pro only,
// with the health-data consent the plan was saved with
export const DIET_PLAN_POINTS = gql`
  mutation DietPlanPoints($numbers: JSON!, $lang: String, $healthDataConsent: Boolean) {
    dietPlanPoints(numbers: $numbers, lang: $lang, healthDataConsent: $healthDataConsent)
  }
`;
